import { render } from "./AccountManagement.vue?vue&type=template&id=6b3230a1&scoped=true"
import script from "./AccountManagement.vue?vue&type=script&lang=js"
export * from "./AccountManagement.vue?vue&type=script&lang=js"

import "./AccountManagement.vue?vue&type=style&index=0&id=6b3230a1&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b3230a1"]])

export default __exports__